import getConfig from 'next/config';

import { reportError } from '@klokhuis/core/Errors';

import { init } from './libs/analytics-lib';

const { publicRuntimeConfig } = getConfig();

const isBrowser = typeof global.window !== 'undefined';

export function initRudderstackAnalytics() {
  if (!isBrowser || !publicRuntimeConfig.RUDDERSTACK_WRITE_KEY) {
    return;
  }

  init({
    rudderstack: {
      writeKey: publicRuntimeConfig.RUDDERSTACK_WRITE_KEY,
      dataPlaneUrl: publicRuntimeConfig.RUDDERSTACK_DATA_PLANE_URL,
      configUrl: publicRuntimeConfig.RUDDERSTACK_CONFIG_URL,
      cdnUrl: publicRuntimeConfig.RUDDERSTACK_CDN_URL,
      loadOptions: {
        cookieConsentManager: {
          oneTrust: { enabled: false },
        },
      },
    },
  })?.catch(reportError);
}
